const axios = require("axios");
/* NodeJS */
const url = process.env.REACT_APP_BASE_FINGI_CORE_BASE_URL;

module.exports = {
  getAvailability: (accessToken, productId, from, to, timeframe, quantity) =>
    axios({
      method: "GET",
      url: `${url}/inventories`,
      params: {
        access_token: accessToken,
        product_id: productId,
        from: from,
        to: to,
        timeframe: timeframe,
        quantity: quantity
      }
    })
};
